const AirQualityMain: React.FC = () => <Outlet />;
export default AirQualityMain;
